import type { Vec2 } from "./types";

export const clamp = (value: number, min: number, max: number): number =>
  Math.max(min, Math.min(max, value));

export const lerp = (from: number, to: number, amount: number): number =>
  from + (to - from) * amount;

export const distanceSquared = (a: Vec2, b: Vec2): number => {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  return dx * dx + dy * dy;
};

export const distance = (a: Vec2, b: Vec2): number =>
  Math.sqrt(distanceSquared(a, b));

export const length = (vector: Vec2): number => Math.hypot(vector.x, vector.y);

export const normalize = (vector: Vec2): Vec2 => {
  const size = length(vector);
  return size > 0.0001
    ? { x: vector.x / size, y: vector.y / size }
    : { x: 0, y: 0 };
};

export const direction = (from: Vec2, to: Vec2): Vec2 =>
  normalize({ x: to.x - from.x, y: to.y - from.y });

export const randomRange = (min: number, max: number): number =>
  min + Math.random() * (max - min);

export const moveToward = (
  current: number,
  target: number,
  maxDelta: number,
): number => {
  if (Math.abs(target - current) <= maxDelta) return target;
  return current + Math.sign(target - current) * maxDelta;
};

export const angleDifference = (from: number, to: number): number =>
  Math.atan2(Math.sin(to - from), Math.cos(to - from));

export const hashNoise = (value: number): number => {
  const noise = Math.sin(value * 12.9898) * 43758.5453;
  return noise - Math.floor(noise);
};
